import { observer } from "mobx-react";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import "./contact-us-buttons.scss";
import { Button } from "../../../../../../components/inputs/button/button";
import IconEmail from "../../../../../../components/icons/icon-email/icon-email";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";
import IconChat from "../../../../../../components/icons/icon-chat/icon-chat";
import currentPortalStore from "../../../../../../stores/current-portal-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { ButtonLink } from "../../../../../../components/inputs/button-link/button-link";
import dashboardStore from "../../../../stores/dashboard-store";
import rmsMixpanelStore from "../../../../../../stores/rms-mixpanel-store";

const ContactUsButtons: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-home';

    const onChatWithUsClick = () => {
        rmsMixpanelStore.trackEvent('d&_home_help_chat');
        dashboardStore.openChat();
    }

    return (
        <div className="contact-us-container">
            <FontBody1>
                {!!currentPortalStore.setting?.isMerchantOnboarded ? (
                    getTranslation('CONTACT_IF_HAVE_A_QUESTION', scope)) : (
                    getTranslation('CONTACT_US_WITH_QUESTION', scope)
                )}
            </FontBody1>
            <div className="contact-us-buttons">
                <div onClick={() => rmsMixpanelStore.trackEvent('d&_home_help_email_us')}>
                    <ButtonLink
                        href={'mailto:support@returngo.ai'}
                        leftIcon={IconEmail}
                        variant={BUTTON_VARIANTS.Secondary}
                        text={getTranslation('EMAIL_US', scope)}
                    />
                </div>
                <Button
                    onClick={onChatWithUsClick}
                    leftIcon={IconChat}
                    variant={BUTTON_VARIANTS.Secondary}
                    text={getTranslation('CHAT_WITH_US', scope)}
                />
            </div>
        </div>
    );
});

export default ContactUsButtons;
